import React from 'react';

const BEACON_KEY = '96ba7c9ef0';

const injectScript = (): void => {
  const e = document.createElement('script');
  e.src = 'https://cdn.sift.com/s.js';
  document.body.appendChild(e);
};

const useSift = (sessionId?: string): void => {
  React.useEffect(() => {
    // Early renders won't yet have the sessionId (sent by the server).
    // Wait for it to exist before injecting the Sift script.
    if (!sessionId || window._sift) {
      return;
    }

    // The user ID doesn't exist, since they haven't signed up yet.
    const userId = '';

    const _sift = (window._sift = window._sift || []);
    _sift.push(['_setAccount', BEACON_KEY]);
    _sift.push(['_setUserId', userId]);
    _sift.push(['_setSessionId', sessionId]);
    _sift.push(['_trackPageview']);

    injectScript();
  }, [sessionId]);
};

export default useSift;
